export default "__VITE_ASSET__BsnIWWW4__"